// GiftModal.js
import giftService from 'pages/gift-module/services/gift.service';
import React from 'react';
import { Button, CloseButton } from 'react-bootstrap';
import { Link } from 'react-router-dom';
import { CSSTransition } from 'react-transition-group';
import StaticModal from 'shared/common/modal/staticModal';
import giftImage from '../../assets/images/gift3.png';
import success from '../../assets/images/check.png';

interface PropsType {
  showModal?: any;
  proceed?: any;
  cancel?: any;
  title?: any;
}
const SuccessGiftModal: React.FC<PropsType> = ({
  showModal,
  proceed,
  cancel,
  title,
}) => {
  return (
    <StaticModal
      show={showModal}
      handleClose={() => cancel()}
      title={title}
      onClose={() => {
        cancel();
      }}
      size='sm'
      center
    >
      <div className='position-relative'>
        {/* Close button is now absolutely positioned */}
        <div className='position-absolute top-0 end-0'>
          <CloseButton onClick={cancel} />
        </div>
      </div>
      {/* <div className='d-flex justify-content-end'>
        <CloseButton onClick={cancel} />
      </div> */}

      <div className='RedeemMainDiv p-3 d-flex flex-column align-items-center text-center h-100'>
        {/* Success Image */}
        <div>
          <img
            src={success}
            className='img-fluid'
            style={{ height: '70px', maxWidth: '100%' }}
          />
        </div>

        {/* Text */}
        <h2 className='m-3' style={{ color: '#301250' }}>
          <i>Success!</i>
        </h2>
        <h6 className='text-1' style={{ fontWeight: 'bold' }}>
          Gift has been successfully claimed.
        </h6>
        <p className='text-1' style={{ color: '#7f7a7a', fontSize: '14px' }}>
          You can go to passbook to check your metal balance
        </p>

        {/* Button */}
        <div className='d-flex justify-content-center'>
          <Button
            className='btn'
            style={{ backgroundColor: '#301250' }}
            onClick={proceed}
          >
            GO TO PASSBOOK
          </Button>
        </div>
      </div>
    </StaticModal>
  );
};

export default SuccessGiftModal;
